export const FUSO_NEGOCIO = 'America/Sao_Paulo';

const DATA_SP = new Intl.DateTimeFormat('en-CA', {
  timeZone: FUSO_NEGOCIO,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** Data civil (`YYYY-MM-DD`) do instante no fuso de negócio. */
export const dataEmSaoPaulo = (instante: Date): string => DATA_SP.format(instante);

/** Hoje (`YYYY-MM-DD`) em São Paulo. Nunca `new Date().toISOString().slice(0, 10)`, que é o dia em UTC. */
export const hojeEmSaoPaulo = (): string => dataEmSaoPaulo(new Date());

const utcDoDia = (dia: string) => Date.UTC(Number(dia.slice(0, 4)), Number(dia.slice(5, 7)) - 1, Number(dia.slice(8, 10)));

/** Dias corridos entre dois dias de negócio (`AAAA-MM-DD`); negativo quando `ate` vem antes de `de`. */
export const diasEntre = (de: string, ate: string): number => Math.round((utcDoDia(ate) - utcDoDia(de)) / 86_400_000);

/** O dia de negócio `n` dias depois (antes, se negativo); conta a partir do meio-dia UTC, que é o mesmo dia em SP. */
/** Dias de negócio (em São Paulo) entre dois instantes: há quantos dias algo está numa etapa. */
export const diasEmSaoPauloEntre = (de: Date, ate: Date): number => diasEntre(dataEmSaoPaulo(de), dataEmSaoPaulo(ate));

export const somarDias = (dia: string, n: number): string => dataEmSaoPaulo(new Date(utcDoDia(dia) + n * 86_400_000 + 12 * 3_600_000));

/** Competência (`YYYY-MM`) do instante em São Paulo. */
export const competenciaEmSaoPaulo = (instante: Date): string => dataEmSaoPaulo(instante).slice(0, 7);

/** Meio-dia UTC do dia 15 cai no mesmo mês em São Paulo: aritmética de mês sem risco de virada de fuso. */
const meioDoMes = (ano: number, mesBaseZero: number) => competenciaEmSaoPaulo(new Date(Date.UTC(ano, mesBaseZero, 15, 12)));

/** A competência seguinte (`2026-12` → `2027-01`). */
export const competenciaSeguinte = (competencia: string): string =>
  meioDoMes(Number(competencia.slice(0, 4)), Number(competencia.slice(5, 7)));

/** As `meses` competências (`AAAA-MM`) que terminam no mês do dia `ate`, mais antiga primeiro. */
export function competenciasAte(ate: string, meses: number): string[] {
  const [ano, mes] = [Number(ate.slice(0, 4)), Number(ate.slice(5, 7))];
  return Array.from({ length: meses }, (_, i) => meioDoMes(ano, mes - meses + i));
}

const OFFSET_SP = new Intl.DateTimeFormat('en-US', { timeZone: FUSO_NEGOCIO, timeZoneName: 'longOffset' });

/** Horário de parede em São Paulo (`YYYY-MM-DDTHH:mm`, o valor do `<input type="datetime-local">`) → instante. */
export function instanteDoHorarioEmSaoPaulo(horario: string): Date {
  const gmt = OFFSET_SP.formatToParts(new Date(`${horario}:00Z`)).find((p) => p.type === 'timeZoneName')?.value ?? 'GMT';
  return new Date(`${horario}:00${gmt === 'GMT' ? 'Z' : gmt.slice(3)}`);
}
